import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { QUERY_KEY } from '~common';
import { getRequest } from '~services';
import { PendingStationPlacementResponse } from '~types';

export type PlacementsRequestParams = {
  managedGroupId?: string | null;
  venueId?: string;
};

export const useQueryGetPlacementsInVenue = (
  reqParams: PlacementsRequestParams,
  options?: Omit<
    UseQueryOptions<
      PendingStationPlacementResponse,
      AxiosError<Record<string, string>>,
      PendingStationPlacementResponse,
      (QUERY_KEY | PlacementsRequestParams)[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const getListPlacement = (): Promise<PendingStationPlacementResponse> =>
    getRequest({
      path: `api/venue-request/list-station-at`,
      params: reqParams,
    }).then((res) => res);

  return useQuery(
    [QUERY_KEY.GET_PLACEMENT_LIST_IN_VENUE, reqParams],
    () => getListPlacement(),
    {
      ...options,
    },
  );
};
